import React, { Component } from "react";
import "./style.css";
import { connect } from "react-redux";
import { Container } from "reactstrap";

import api from "../../config/api";
import PageHead from "../../component/pageHead/PageHead";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import authAction from "../../redux/auth/action";
import dashboardAction from "../../redux/dashboard/action";
import {
  formatNumbers,
  isNetworkRequestFailedError,
  isUserMember,
} from "../../config/helpers";
import bannerPopupActions from "../../redux/bannerPopup/action";
import FloatingButton from "../../component/FloatingButton";

class NonMemberDashboard extends Component {
  state = {
    currentFunPriceArr: "",
    isLoading: false,
  };

  componentDidMount() {
    if (this.props.user && !this.props.currentFunPriceArr) {
      const token = this.props.user.token;
      this.fetchingInfo(token);
      this.showMemberConvertTextPopup();
    }
  }

  showMemberConvertTextPopup = () => {
    if (isUserMember(this.props.user)) {
      return;
    }

    this.props.setBannerPopup({
      visible: true,
      title: "Message",
      message: [
        "To change your user type to Member/customer, to enable you view your RSA-account details",
        "Kindly Contact customer service via --- csu@premiumpension.com, 09 461 5700-4, 09-7000020",
      ],
    });
  };

  componentWillReceiveProps(nextProps) {
    const token = nextProps.user.token;
    const { currentFunPriceArr: nextFundPrice } = nextProps;
    const { currentFunPriceArr: prevFundPrice } = nextProps;

    if (JSON.stringify(nextFundPrice) !== JSON.stringify(prevFundPrice)) {
      this.fetchingInfo(token);
    }
  }

  fetchingInfo = async (token) => {
    this.setState({ isLoading: true });

    const { setAlertMessage, setNonMemberDashboardValues } = this.props;
    const allFundName = await api.fetchAllFundNames();
    const allFundNameArr = allFundName.data.result;
    const arr = [
      allFundNameArr[0].FUND_ID,
      allFundNameArr[1].FUND_ID,
      allFundNameArr[2].FUND_ID,
      allFundNameArr[3].FUND_ID,
    ];
    try {
      const currentPrices = await Promise.all([
        api.fetchCurrentPrice({ fundId: arr[0] }, token),
        api.fetchCurrentPrice({ fundId: arr[1] }, token),
        api.fetchCurrentPrice({ fundId: arr[2] }, token),
        api.fetchCurrentPrice({ fundId: arr[3] }, token),
      ]);
      setNonMemberDashboardValues(currentPrices);
      this.setState({ currentFunPriceArr: currentPrices });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? () => this.fetchingInfo(token)
          : null,
      });
    }
    this.setState({ isLoading: false });
  };

  navigateToReferral = () => {
    this.props.history.push("/referral");
  };

  render() {
    const { isLoading } = this.state;
    const { currentFunPriceArr } = this.props;

    return (
      <Container>
        <PageHead
          title="NON-MEMBER DASHBOARD"
          containerStyles={{ width: "100%" }}
        />
        {isLoading && <CustomLoader text="Fetching Fund Price" />}
        {currentFunPriceArr && (
          <div>
            <ul className="my-2 pl-0">
              <li className="non-member-dashboard-list-container">
                <span className="pl-3">
                  {currentFunPriceArr[0].data.result.FundName}
                </span>
                <span>
                  {formatNumbers(
                    currentFunPriceArr[0].data.result.UnitPrice,
                    true
                  )}
                </span>
              </li>
            </ul>
            <div className="bottom-tag-container">
              <div>
                <p>Current Price</p>
              </div>
            </div>
            <ul className="my-2 pl-0">
              <li className="non-member-dashboard-list-container">
                <span className="pl-3">
                  {currentFunPriceArr[1].data.result.FundName}
                </span>
                <span>
                  {formatNumbers(
                    currentFunPriceArr[1].data.result.UnitPrice,
                    true
                  )}
                </span>
              </li>
            </ul>
            <div className="bottom-tag-container">
              <div>
                <p>Current Price</p>
              </div>
            </div>

            <ul className="my-2 pl-0">
              <li className="non-member-dashboard-list-container">
                <span className="pl-3">
                  {currentFunPriceArr[2].data.result.FundName}
                </span>
                <span>
                  {formatNumbers(
                    currentFunPriceArr[2].data.result.UnitPrice,
                    true
                  )}
                </span>
              </li>
            </ul>
            <div className="bottom-tag-container">
              <div>
                <p>Current Price</p>
              </div>
            </div>

            <ul className="my-2 pl-0">
              <li className="non-member-dashboard-list-container">
                <span className="pl-3">
                  {currentFunPriceArr[3].data.result.FundName}
                </span>
                <span>
                  {formatNumbers(
                    currentFunPriceArr[3].data.result.UnitPrice,
                    true
                  )}
                </span>
              </li>
            </ul>
            <div className="bottom-tag-container">
              <div>
                <p>Current Price</p>
              </div>
            </div>
          </div>
        )}
        <FloatingButton
          onClick={this.navigateToReferral}
          style={{ position: "absolute" }}
          position="BOTTOM_CENTER"
        >
          Referral
        </FloatingButton>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  currentFunPriceArr: state.dashboard.nonMember,
});

const mapDispatchToProps = {
  setAlertMessage: authAction.setAlertMessage,
  setNonMemberDashboardValues: dashboardAction.setNonMemberDashboardValues,
  setBannerPopup: bannerPopupActions.setBannerPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(NonMemberDashboard);
